export const hy = {
    nav: {
        home: "Գլխավոր էջ",
        about: "Մեր մասին",
        services: "Ծառայություններ",
        contact: "Կապ",
        consultation: "Խորհրդատվություն",
        subTitle: "Law & Consultancy",
        workingHours: "Երկ - Ուրբ: 09:00 - 18:00"
    },
    hero: {
        slides: [
            {
                title: "Պրոֆեսիոնալ Իրավաբանական և փաստաբանական ծառայություններ",
                description: "Տարիների փորձ իրավաբանության ոլորտում"
            },
            {
                title: "Բարձրակարգ կորպորատիվ սպասարկման ծառայություններ",
                description: "Ձեր բիզնեսի իրավական խնդիրների նախականխում, կանխում և լուծում"
            },
            {
                title: "Անհատական մոտեցում յուրաքանչյուր վստահորդին",
                description: "Առաջնահերթություն ենք տալիս յուրաքանչյուր վստահորդի անհատական պահանջներին"
            }
        ],
        btnConsultation: "Խորհրդատվություն",
        btnServices: "Ծառայություններ",
        stats: {
            yearsExp: "Տարիների փորձ",
            cases: "Դատական գործ",
            successRate: "Հաջողված գործ",
            confidentiality: "Գաղտնիություն"
        }
    },
    marquee: "Ձեր Իրավունքի պաշտպանությունը մեր առաքելությունն է։",
    home: {
        practiceTitle: "Ծառայությունների Ոլորտները",
        practiceAreas: [
            {
                title: "Քաղաքացիական իրավունք",
                description: "Ձեր իրավունքների և օրինական շահերի պաշտպանություն մասնավոր իրավունքին առնչվող ցանկացած գործով"
            },
            {
                title: "Վարչական Իրավունք",
                description: "Ձեր իրավական պաշտպանը պետական մարմինների հետ հարաբերություններում։"
            },
            {
                title: "Կորպորատիվ Իրավունք",
                description: "Ընկերությունների կորպորատիվ իրավաբանական սպասարկում և ցանկացած իրավական խնդրի լուծում"
            }
        ],
        btnMore: "Ավելին",
        whyChooseUs: "Ինչու՞ ընտրել մեզ",
        learnMore: "Իմանալ Ավելին",
        ctaTitle: "Պատրաստ ենք քննարկել Ձեզ հուզող բոլոր իրավական հարցերը",
        ctaText: "Կապ հաստատեք մեր մասնագետների հետ այսօր և ստացեք առաջնային պրոֆեսիոնալ խորհրդատվություն:",
        btnCallNow: "Զանգահարել Հիմա",
        btnSendMessage: "Ուղարկել Հաղորդագրություն",
        toastCallTitle: "Զանգահարեք մեզ",
        toastCallDesc: "Հեռախոսահամար՝ +374 77 53 13 09"
    },
    about: {
        pageTitle: "Ընկերության Մասին",
        pageSubtitle: "2023 թվականից մենք ապահովում ենք պրոֆեսիոնալ իրավաբանական և փաստաբանկան ծառայությունների մատուցում՝ մասնավոր իրավունքի, վարչական իրավունքի և կորպորատիվ իրավունքի բնագավառներում:",
        stats: [
            { value: "5+", label: "Տարիների փորձ" },
            { value: "200+", label: "Դատական գործեր" },
            { value: "94%", label: "Հաջողված գործեր" }
        ],
        foundersTitle: "Ընկերության հիմնադիրները",
        team: [
            {
                name: "Արեն Վարդանի Անտոնյան",
                role: "Համահիմնադիր-փաստաբան",
                specialization: "Քաղաքացիական իրավունք, վարչական իրավունքի, կորպորատիվ իրավունք, սնանկություն, գնումներ",
                experience: "5 տարի",
                experienceLabel: "Փորձ"
            },
            {
                name: "Աշոտ Արամի Գրիգորյան",
                role: "Համահիմնադիր-տնօրեն",
                specialization: "Քաղաքացիական իրավունք, վարչական իրավունքի, կորպորատիվ իրավունք, սնանկություն, մտավոր սեփականության իրավունք",
                experience: "5 տարի",
                experienceLabel: "Փորձ"
            }
        ],
        btnViewDetails: "Տեսնել ավելին",
        historyTitle: "Մեր Պատմությունը",
        historyP1: "Ընկերությունը հիմնադրվել է 2023թ-ին։ Հիմնադրման օրվանից մեր իրավաբանները և փաստաբանները պաշտպանել են անձանց իրավունքներն ու շահերը:",
        historyP2: "Արդյունքում մեր վստահորդները լիովին գոհ են եղել ցուցաբերված մոտեցումից և ստացած իրավական աջակցությունից:",
        historyP3: "Մենք հավատարիմ ենք մնում մեր արժեքներին՝ արդարություն, աշխատասիրություն, և անհատական մոտեցում յուրաքանչյուրին:",
        valuesTitle: "Մեր Արժեքները",
        values: [
            {
                title: "Արդարության վերականգնում",
                description: "Մեր վստահորդների իրավունքների և օրինական շահերի պաշտպանության համար մենք պայքարում ենք բոլոր ատյաններում։"
            },
            {
                title: "Պրոֆեսիոնալիզմ",
                description: "Մենք առաջարկում ենք ամենաօպտիմալ և հեռանկարային լուծումները։"
            },
            {
                title: "Հավատարմություն",
                description: "Մենք հավատարիմ ենք մեր ընկերության կողմից որդեգրած արժեքներին։"
            },
            {
                title: "Պատասխանատվություն",
                description: "Ընկերության յուրաքանչյուր աշխատակցի կողմից տրամադրված խորհրդատվությունը կամ իրավական լուծումը մատուցվում է ամենաբարձր մակարդակով։"
            }
        ],
        ctaTitle: "Պատրաստ ենք քննարկել Ձեր իրավական խնդիրները",
        ctaText: "Կապ հաստատեք մեր թիմի հետ և ստացեք առաջնային խորհրդատվություն:",
        btnContactUs: "Կապ մեզ հետ"
    },
    services: {
        pageTitle: "Պրոֆեսիոնալ Իրավաբանական և փաստաբանական ծառայություններ",
        btnViewAll: "Դիտել բոլոր ծառայությունները",
        items: [
            {
                title: "Իրավաբանական խորհրդատվություն",
                services: [
                    "Բանավոր Իրավաբանական խորհրդատվության տրամադրում",
                    "Գրավոր Իրավաբանական խորհրդատվության տրամադրում"
                ]
            },
            {
                title: "Կորպորատիվ իրավունք",
                services: [
                    "Իրավաբանական անձանց հիմնադրում, վերակազմակերպում և լուծարում (ներառյալ օտարերկրյա իրավաբանական անձանց)",
                    "Իրավաբանական անձանց կորպորատիվ սպասարկում"
                ]
            },
            {
                title: "Պայմանագրային իրավունք",
                services: [
                    "Բանակցությունների վարում (նաև օտարերկրյա կազմակերպությունների հետ)",
                    "Պայմանագրերի կազմում",
                    "Պայմանագրերի վավերացման գործընթացի կազմակերպում"
                ]
            },
            {
                title: "Վարչական իրավունք",
                services: [
                    "Վարչական ակտերի բողոքարկում (տուգանքներ, տույժեր և այլն)",
                    "Վարչական մարմինների գործողությունների և անգործությունների բողոքարկում"
                ]
            },
            {
                title: "Սնանկություն",
                services: [
                    "Կամավոր սնանկության դիմումների կազմում",
                    "Հարկադրված սնանկության դիմումների կազմում",
                    "Ներկայացուցչություն սնանկության վարույթում"
                ]
            },
            {
                title: "Աշխատանքային",
                services: [
                    "Մինչդատական ներկայացուցչություն աշխատանքային իրավահարաբերություններում",
                    "Դատական ներկայացուցչություն աշխատանքային իրավահարաբերություններում"
                ]
            },
            {
                title: "Գնումներ",
                services: [
                    "Ներկայացուցչություն պետական գնումների հետ կապված վեճերով",
                    "Ներկայացուցչություն մասնավոր գնումների հետ կապված վեճերով"
                ]
            },
            {
                title: "Ապահովագրություն",
                services: [
                    "Ապահովագրական հարաբերություններ"
                ]
            },
            {
                title: "Կատարողական վարույթ",
                services: [
                    "Կատարողական վարույթի սպասարկում"
                ]
            },
            {
                title: "Արբիտրաժային վարույթ",
                services: [
                    "Ներկայացուցչություն արբիտրաժային վարույթում"
                ]
            },
            {
                title: "Կառուցապատում",
                services: [
                    "Կառուցապատման հարաբերություններ"
                ]
            },
            {
                title: "Դատական ներկայացուցչություն",
                services: [
                    "Ներկայացուցչություն սեփականության իրավունքի պաշտպանության գործերով",
                    "Ներկայացուցչություն հողային իրավունքի պաշտպանության գործերով",
                    "Ներկայացուցչություն մտավոր սեփականության իրավունքի պաշտպանության գործերով",
                    "Ներկայացուցչություն ընտանեկան իրավունքի պաշտպանության գործերով",
                    "Ներկայացուցչություն ժառանգության իրավունքի պաշտպանության գործերով",
                    "Ներկայացուցչություն բոլոր տեսակի քաղաքացիական, վարչական և սնանկության գործերով"
                ]
            }
        ]
    },
    connect: {
        heroTitle: "Ինչո՞ւ դիմել մեզ",
        heroText: "Մեր փորձառու իրավաբանական թիմը պատրաստ է աջակցել Ձեզ՝ ապահովելով գաղտնիություն, պարտաճանաչություն և մշտական հասանելիություն։",
        badgeLawyers: "Փորձառու իրավաբաններ",
        badgeFast: "Արագ արձագանք",
        badgePrivacy: "100% Գաղտնիություն",
        btnSendInquiry: "Ուղարկել հարցում",
        formTitle: "Կապ մեզ հետ",
        labelName: "Անուն",
        placeholderName: "Ձեր անունը",
        labelLastname: "Ազգանուն",
        placeholderLastname: "Ձեր ազգանունը",
        labelSurname: "Հայրանուն",
        placeholderSurname: "Ձեր հայրանունը",
        labelEmail: "Էլեկտրոնային հասցե",
        placeholderEmail: "Ձեր էլ. փոստի հասցեն",
        labelPhone: "Հեռախոսահամար",
        placeholderPhone: "Ձեր հեռախոսահամարը",
        labelMessage: "Ձեր հաղորդագրությունը",
        placeholderMessage: "Հակիրճ նկարագրեք Ձեր խնդիրը...",
        btnSubmit: "Ուղարկել հաղորդագրություն",
        btnSubmitting: "Ուղարկվում է...",
        toastSuccessTitle: "Հաղորդագրությունն ուղարկված է",
        toastSuccessDesc: "Շնորհակալություն, մենք կապ կհաստատենք Ձեզ հետ շուտով:",
        toastErrorTitle: "Սխալ",
        toastErrorDesc: "Չհաջողվեց ուղարկել: Խնդրում ենք փորձել կրկին:",
        infoTitle: "Կոնտակտային տվյալներ",
        addressTitle: "Գրասենյակի հասցե",
        addressValue: "Հ, ք. Երևան, Տոլբուխինի 34 - Մամիկոնյանց Ն.Տիգրանյան խաչմերուկ",
        btnSeeMap: "Տեսնել քարտեզում",
        phonesTitle: "Հեռախոսահամարներ",
        emailTitle: "Էլեկտրոնային հասցե",
        daysTitle: "Աշխատանքային օրեր",
        daysValue: "Երկուշաբթի - Ուրբաթ",
        hoursTitle: "Աշխատանքային ժամեր",
        hoursValue: "09:00 - 18:00"
    },
    modal: {
        mapTitle: "Մեր գրասենյակի վայրը",
        close: "Փակել",
        experienceClose: "Փակել"
    },
    testimonials: {
        badge: "ՎՍՏԱՀՈՐԴՆԵՐԻ ԿԱՐԾԻՔՆԵՐ",
        title: "Ի՞նչ են ասում մեր մասին",
        subtitle: "Մեր ամենամեծ հաջողությունը մեր գոհ և պաշտպանված վստահորդների երախտագիտությունն է:",
        reviews: [
            {
                quote: "LegalTitan-ի թիմը ապահովել է պատշաճ դատական ներկայացուցչություն, որի արդյունքում իմ սեփականության իրավունքը վերականգնվել է։ Շատ շնորհակալ եմ բարձր պրոֆեսիոնալիզմի համար։",
                author: "Աննա Ս․",
                role: "Անհատ ձեռներեց",
                rating: 5
            },
            {
                quote: "Մեր ընկերությունը բազմիցս դիմել է «Լեգալ Տիտան» ՍՊԸ-ին հանրային և հարկային իրավունքի բնագավառում ծագած խնդիրներով և մշտապես ստացել է ամենաօպտիմալ իրավական լուծումները։",
                author: "Արմեն Կ․",
                role: "Տնօրեն, Շինարարական Ընկերություն",
                rating: 5
            },
            {
                quote: "Մենք մշտական համագործակցության նպատակով 2023թ-ին դիմել ենք «Լեգալ Տիտան»-ին և մինչ այժմ համագործակցում ենք։ Բոլոր իրավական հարցերը լուծվում են օպերատիվ և անթերի։",
                author: "Գարիկ Մ․",
                role: "Հիմնադիր, ՏՏ Ընկերություն",
                rating: 5
            }
        ]
    },
    footer: {
        description: "Ընկերությունը մատուցում է բարձրակարգ իրավաբանական և փաստաբանական ծառայություններ՝ հիմնված տարիների փորձի, պրոֆեսիոնալիզմի և 100% գաղտնիության վրա:",
        quickLinks: "ԱՐԱԳ ՀՂՈՒՄՆԵՐ",
        practiceAreas: "ՈԼՈՐՏՆԵՐ",
        contactInfo: "ԿԱՊԻ ՏՎՅԱԼՆԵՐ",
        copyright: "LegalTitan LLC. Բոլոր իրավունքները պաշտպանված են:",
        badgeProtection: "Պրոֆեսիոնալ Իրավաբանական Պաշտպանություն Հայաստանում"
    }
};
